import { type KeyboardEvent, useCallback } from 'react'
import { type Observable } from 'rxjs'
import { TextArea } from '@/components/inputs/TextArea'

export interface TextQuestionAnswerEditorProps {
  value: string
  isDisabled: boolean
  onChange: (value: string) => unknown
  onCommit: () => unknown
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
  testId?: string
}

export function TextQuestionAnswerEditor({
  value,
  isDisabled,
  onChange,
  onCommit,
  onEnterDown,
  focus$,
  onFocus,
  isNotValid,
  testId,
}: TextQuestionAnswerEditorProps) {
  const keyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        onCommit()
        onEnterDown?.(e)
      }
    },
    [onEnterDown, onCommit],
  )

  return (
    <div>
      <TextArea
        autoSize
        isDisabled={isDisabled}
        rows={1}
        focus$={focus$}
        onFocus={onFocus}
        value={value}
        onBlur={onCommit}
        placeholder={isDisabled ? 'Text' : 'Text (Shift + Enter for new line)'}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={keyDown}
        isNotValid={isNotValid}
        data-test={testId}
      />
    </div>
  )
}
